function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -283.77)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.034123 0 0 .034123 .88195 284.65)",
  imageRendering: "optimizeQuality",
  shapeRendering: "geometricPrecision"
}, /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "m38 38c51-51 134-51 185 0 50 51 50 134 0 185-51 50-134 50-185 0-51-51-51-134 0-185zm21 21c-39 40-39 103 0 143 39 39 103 39 143 0 39-40 39-104 0-143-40-39-103-39-143 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil1",
  d: "m254 215 74 75c11 10 11 28 0 38-10 11-28 11-38 0l-75-74c8-5 15-11 21-18 7-6 13-13 18-21z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "m44 121c3-19 12-37 26-51s32-23 51-26l3 20c-16 2-30 9-40 20-11 10-18 24-20 40z"
})));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 13.229 13.229",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.6eb5a451.svg";
export { ForwardRef as ReactComponent };